import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import "../navbar/navbar.scss"

const Navbar = () => {
    const [isActive, setIsActive] = useState(false);
    const [isScroll, setIsScroll] = useState(false);
    const [activeMenu, setActiveMenu] = useState(null); // Speichert das aktive Untermenü

    const handleClick = () => {
        setIsActive((current) => !current);
        setActiveMenu(null); // Schließt alle Untermenüs
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsScroll(window.scrollY >= 1);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className="nav">
            <div className={isActive ? "navbar active" : isScroll ? "navbar scroll" : "navbar"}>
                <div className="container">
                    <Link className="left" to={"/"}>
                        <img src="/assets/logo.svg" alt="Logo Musikkapelle St. Lorenzen" />
                    </Link>
                    <div className="right">
                        <div className={isActive ? "openNav active" : "openNav"} onClick={handleClick}>
                            <div className="navLines"></div>
                            <div className="navLines"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={isActive ? "navModal open" : "navModal"}>
                <div className="container">
                    <AnimatePresence mode="wait">
                        {activeMenu === null ? (
                            <motion.div
                                key="mainMenu"
                                className="top"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -100 }}
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                <NavLink to={"/"} className="lineLink" onClick={handleClick}>Home</NavLink>
                                <span className="lineLink" onClick={() => setActiveMenu("kapelle")}>Kapelle</span>
                                <span className="lineLink" onClick={() => setActiveMenu("jugend")}>Jugend</span>
                                <NavLink to={"/boehmische"} className="lineLink" onClick={handleClick}>Böhmische</NavLink>
                                <NavLink to={"/kontakt"} className="lineLink" onClick={handleClick}>Kontakt</NavLink>
                            </motion.div>
                        ) : (
                            <motion.div
                                key={activeMenu}
                                className="submenu"
                                initial={{ opacity: 0, x: 100 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 100 }}
                                transition={{ duration: 0.2, ease: "easeOut" }}
                            >
                                <span className="back" onClick={() => setActiveMenu(null)}>
                                    <KeyboardBackspaceIcon />
                                    <span>zurück</span>
                                </span>
                                {activeMenu === "kapelle" && (
                                    <>
                                        <Link to={"/kapelle"} className="lineLink big" onClick={handleClick}>Kapelle</Link>
                                        <Link to={"/kapelle#geschichte"} className="lineLink" onClick={handleClick}>Geschichte</Link>
                                        <Link to={"/kapelle/mitglieder"} className="lineLink" onClick={handleClick}>Mitglieder</Link>
                                        <Link to={"/kapelle/vorstand"} className="lineLink" onClick={handleClick}>Vorstand</Link>
                                        <Link to={"/kapelle#musikfahne"} className="lineLink" onClick={handleClick}>Musikfahne</Link>
                                    </>
                                )}
                                {activeMenu === "jugend" && (
                                    <>
                                        <Link to={"/jugend/jugendkapelle"} className="lineLink big" onClick={handleClick}>Jugendkapelle</Link>
                                        <Link to={"/jugend/blaeserklasse"} className="lineLink" onClick={handleClick}>Bläserklasse</Link>
                                    </>
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>
                    <div className="bottom">
                        <motion.div
                            className="left"
                            initial={{ opacity: 0, x: -100 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                        >
                            <NavLink to={"/oeffentliche-beitraege"} className="lineLink" onClick={handleClick}>Öffentliche Beiträge</NavLink>
                            <NavLink to={"/impressum"} className="lineLink" onClick={handleClick}>Impressum</NavLink>
                            <NavLink to={"/datenschutz"} className="lineLink" onClick={handleClick}>Datenschutz</NavLink>
                        </motion.div>
                        <motion.div
                            className="right"
                            initial={{ opacity: 0, x: 100 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                        >
                            <Link to="mailto:info@mk-lorenzen.it" className="lineLink">info@mk-lorenzen.it</Link>
                            <Link to="tel:+393889544759" className="lineLink">+39 388 954 4759</Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>

    )
};

export default Navbar